import { CmsApiFlashCardQuizBlockData } from 'modules/cms/api/types/blocks/CmsApiFlashCardQuizBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsAmpFlashCardQuizBlock } from './CmsAmpFlashCardQuizBlock';
import { CmsFlashCardQuizBlock } from './CmsFlashCardQuizBlock';

export const CmsFlashCardsQuizBlockMapping: CmsBlockMapping<CmsApiFlashCardQuizBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsFlashCardQuizBlock,
    AmpComponent: CmsAmpFlashCardQuizBlock,
  };
